import { isEmpty } from 'lodash';

import { ProductDetailContent, ProductDetailContentModule } from '../../types';

const findBlockType = (contents: ProductDetailContent[], type: string) => contents
  .find((content) => content.blockType === type);

const filteredImageData = (target: ProductDetailContent) => target?.modules
  .filter((module) => module.moduleType === 'IMAGE')
  .find(it => !isEmpty(it.data));

const findTargetImage = (target: ProductDetailContentModule, isPC: boolean) => {
  if (!isPC) {
    return target?.data.find((it) => it.mobileImage)?.mobileImage;
  }

  return target?.data.find((it) => it.pcImage)?.pcImage;
};

// 컬리 파트너스 BODY 타입 이미지 parser
export function partnerBodyImageBuilder(partnerContent: ProductDetailContent[], isPC: boolean) {
  const partnerBody = findBlockType(partnerContent, 'BODY');

  if (!partnerBody) {
    return;
  }

  const partnerBodyImages = filteredImageData(partnerBody);

  if (!partnerBodyImages) {
    return;
  }

  return findTargetImage(partnerBodyImages, isPC);
}

// 컬리 파트너스 PRODUCT_IMAGE 타입 이미지 parser
export function partnerProductImageBuilder(partnerContent: ProductDetailContent[], isPC: boolean) {
  const partnerProduct = findBlockType(partnerContent, 'PRODUCT_IMAGE');

  if (!partnerProduct) {
    return;
  }

  const partnerProductImages = filteredImageData(partnerProduct);

  if (!partnerProductImages) {
    return;
  }

  return findTargetImage(partnerProductImages, isPC);
}
